/* import __COLOCATED_TEMPLATE__ from './dismissible-content-card.hbs'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { OneTrustConsent } from '@square/dashboard-utilities/utils/one-trust/one-trust-compliance';
import { get as persistableGet, set as persistableSet } from '@square/dashboard-utilities/utils/persistable';
export const STORAGE_PREFIX = 'dismissibleCard';
let DismissibleContentCard = (_class = class DismissibleContentCard extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "localStorageKey", `${STORAGE_PREFIX}.${this.args.storageKey}`);
    _initializerDefineProperty(this, "isDismissed", _descriptor, this);
  }
  onDismiss() {
    try {
      persistableSet(this.localStorageKey, true, OneTrustConsent.FUNCTIONAL);
    } catch {
      // If there's an error with setting localStorage
      // (for example: the user's localStorage is full), do nothing.
    }
    this.isDismissed = true;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "isDismissed", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return persistableGet(this.localStorageKey);
  }
}), _applyDecoratedDescriptor(_class.prototype, "onDismiss", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onDismiss"), _class.prototype), _class);
export { DismissibleContentCard as default };